export interface Conflict {
  userId: string
  userFullName: string
  updatedOn: Date
}

/**
 * True only if `data` actually has the shape of a ConflictDto. Locks, reservations, chat
 * read-markers, etc. also raise 409s but their body is not a ConflictDto - callers must use
 * this guard instead of assuming "409 => conflict" so the check stays correct as new 409-raising
 * endpoints are added, without needing to know their URLs. (Bug 67353)
 */
export function isConflictDto(data: unknown): data is Conflict {
  if (!data || typeof data !== 'object') return false
  const candidate = data as Record<string, unknown>
  return (
    typeof candidate.userId === 'string' &&
    typeof candidate.userFullName === 'string' &&
    typeof candidate.updatedOn === 'string' &&
    candidate.updatedOn.length > 0
  )
}
